module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';

	fox.registerWidget('Menu_Service', {
		configure: function () {
			this.registerOptions('', {
				widgets: {
					menu: {
						widget: 'Widget',
						autoRender: true,
						template: 'menu_service',
						embed: {
							widget: '@parent @parent'
						}
					}
				},

				handleDom: {
					logout: {
						targetWidget: '#menu',
						target: '#logout',
						event: 'click',
						callback: function () {
							fox.site.logout();
						}
					},
					community: {
						targetWidget: '#menu',
						target: '#community',
						event: 'click',
						callback: '@parent @parent @parent:community'
					}
				}
			});

			this.callParent('configure', arguments);
		}
	}, 'Menu_Section');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/menu/service.js
// module id = 330
// module chunks = 2